import { getActiveChainId } from './active'
import type { ChainAccessMode, WidgetChainScope } from './types'

export function resolveWidgetChainScope(
  scope?: WidgetChainScope,
  defaultMode: ChainAccessMode = 'write',
): WidgetChainScope {
  if (scope) {
    return scope
  }
  return {
    chainId: getActiveChainId(),
    mode: defaultMode,
  }
}
